module.exports = __webpack_public_path__ + "static/img/zhuanli04.a5e415c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli04.png
// module id = np9p
// module chunks = 1